import { TmAuthVerificationTryAgainInTimeError } from '@/core/error/transport/auth/TmAuthVerificationTryAgainInTimeError'
import type { CustomErrorRule } from '@/core/error/transport/types'
import { EndpointsEnum } from '@/services/endpoints'

export const authVerificationTryAgainInTimeErrorRule: CustomErrorRule = {
  endpoint: EndpointsEnum.sendVerifyCodeOnPhone,
  subCodes: ['user.verification.try_again_in_time'],
  klass: TmAuthVerificationTryAgainInTimeError,
}
